import * as React from 'react';
import { MainModel } from './../Models/mainModel';
import { actionTypes } from './../Constants/constants';

const initialState = new MainModel();

export function mainReducer(state: any = initialState, action: any): any {

    switch (action.type) {
        case actionTypes.startLoadingMaster:
            var retObj = (Object as any).assign({}, state, {
                IsMasterLoading: true
            });
            return retObj;
        case actionTypes.endLoadingMaster:
            var retObj = (Object as any).assign({}, state, {
                IsMasterLoading: false
            });

            return retObj;
        case actionTypes.startLoadingPage:
            var retObj = (Object as any).assign({}, state, {
                IsPageLoading: true
            });
            return retObj;
        case actionTypes.endLoadingPage:
            var retObj = (Object as any).assign({}, state, {
                IsPageLoading: false
            });
            return retObj;
        case actionTypes.loadMasterDataLoaded:
            var retObj = (Object as any).assign({}, state, {
                MasterModel: action.MasterModel,
                MasterPageFaliedToLoad: false
            });
            return retObj;
        case actionTypes.loadMasterDataFailedToLoad:
            var retObj = (Object as any).assign({}, state, {
                MasterModel: null,
                MasterPageFaliedToLoad: false
            });
            return retObj;
        case actionTypes.homePageDataLoaded:
             var retObj = (Object as any).assign({}, state, {
                HomeModel: action.HomeModel,
                HomePageFaliedToLoad: false
            });
            return retObj;
        case actionTypes.homePageDataFailedToLoad:
            var retObj = (Object as any).assign({}, state, {
                HomeModel: null,
                HomePageFaliedToLoad: true
            });
            return retObj;
        case actionTypes.aboutUsPageDataLoaded:
            var retObj = (Object as any).assign({}, state, {
                AboutUsModel: action.AboutUsModel,
                AboutUsFaliedToLoad: false
            });
            return retObj;
        case actionTypes.aboutUsPageDataFailedToLoad:
            var retObj = (Object as any).assign({}, state, {
                AboutUsModel: null,
                AboutUsFaliedToLoad: true
            });
            return retObj;
        case actionTypes.servicesPageDataLoaded:
            var retObj = (Object as any).assign({}, state, {
                ServicesModel: action.ServicesModel,
                ServicesFaliedToLoad: false
            });
            return retObj;
        case actionTypes.servicesPageDataFailedToLoad:
            var retObj = (Object as any).assign({}, state, {
                ServicesModel: null,
                ServicesFaliedToLoad: true
            });
            return retObj;
        case actionTypes.contactsPageDataLoaded:
            var retObj = (Object as any).assign({}, state, {
                ContactsModel: action.ContactsModel,
                ContactsFaliedToLoad: false
            });
            retObj.ContactsModel.IsSubmittingRequest = false;
            retObj.ContactsModel.SubmitRequestSuccessMessage = null;
            retObj.ContactsModel.SubmitRequestErrorMessage = null;
            return retObj;
        case actionTypes.contactsPageDataFailedToLoad:
            var retObj = (Object as any).assign({}, state, {
                ContactsModel: null,
                ContactsFaliedToLoad: true
            });
            return retObj;
        case actionTypes.setSubmittingRequest:
            var retObj = (Object as any).assign({}, state, {
                ContactsModel: {
                    ...state.ContactsModel,
                    IsSubmittingRequest: action.IsSubmittingRequest
                }
            });
            return retObj;
        case actionTypes.setSuccessMessages:

            var retObj = (Object as any).assign({}, state, {
                ContactsModel: {
                    ...state.ContactsModel,
                    SubmitRequestSuccessMessage: action.SubmitRequestSuccessMessage,
                    SubmitRequestErrorMessage: action.SubmitRequestErrorMessage,
                }
            });
            return retObj;
    }

    return state;
}




// WEBPACK FOOTER //
// ./ClientApp/app/Reducers/mainReducer.tsx